// TODO (JM): remove when this branch comes alive again https://github.com/NexcorFoodSafety/ckWeb/tree/experimental/anchor-positioning-floating-fallback
export default defineNuxtPlugin((nuxtApp) => {
  // Attempt to use the native showPopover method if available when the element is created
  nuxtApp.vueApp.directive("show-popover", {
    created(el) {
      el.setAttribute("popover", "manual");
    },
    mounted(el) {
      try {
        const isShowPopoverAvailable =
          "showPopover" in HTMLElement.prototype && typeof HTMLElement.prototype.showPopover === "function";

        if (isShowPopoverAvailable && document.body.contains(el)) {
          el.showPopover();
        }
      } catch (error) {
        devConsole.error("Error showing popover:", error);
      }
    },
  });
});
